import { Platform, SyncColor } from "@/store/theme-store";

export type Preset = {
  label: string;
  colors: Record<Platform, SyncColor>;
};

/**
 * Light mode presets for each platform
 *
 * Use `bun scripts/url-to-theme.ts` to convert a URL hash to a preset
 */
export const presets: Preset[] = [
  {
    label: "Red",
    colors: {
      ios: {
        primary: "#D41E1E",
        secondary: "#CB7F4C",
        accent: "#CDBF65",
        muted: "#DBD2D2",
      },
      android: {
        primary: "#A15A4C",
        secondary: "#87665F",
        accent: "#756F46",
        muted: "#D9D6D5",
      },
      web: {
        primary: "#A15A4C",
        secondary: "#87665F",
        accent: "#777144",
        muted: "#E0DCDB",
      },
    },
  },
  {
    label: "Green",
    colors: {
      ios: {
        primary: "#3D8417",
        secondary: "#9BDE94",
        accent: "#56DCDE",
        muted: "#D6DCD3",
      },
      android: {
        primary: "#78AE75",
        secondary: "#90A78E",
        accent: "#68ADAE",
        muted: "#D8DBD8",
      },
      web: {
        primary: "#78AE75",
        secondary: "#90A78E",
        accent: "#65B0B2",
        muted: "#DEE1DE",
      },
    },
  },
  {
    label: "Orange",
    colors: {
      ios: {
        primary: "#FF7A22",
        secondary: "#A56D14",
        accent: "#A4A578",
        muted: "#DFD8D4",
      },
      android: {
        primary: "#D2936F",
        secondary: "#BA9C8C",
        accent: "#A4A578",
        muted: "#DCD9D7",
      },
      web: {
        primary: "#D2936F",
        secondary: "#BA9C8C",
        accent: "#A6A776",
        muted: "#E3DFDC",
      },
    },
  },
  {
    label: "Blue",
    colors: {
      ios: {
        primary: "#007BFF",
        secondary: "#2db9e3",
        accent: "#ff2854",
        muted: "#D2D8DE",
      },
      android: {
        primary: "#006FE7",
        secondary: "#b0c9ff",
        accent: "#a949cc",
        muted: "#D1D7DD",
      },
      web: {
        primary: "#006EE3",
        secondary: "#b0c9ff",
        accent: "#a949cc",
        muted: "#D7DDE4",
      },
    },
  },
];
